module.exports = __webpack_public_path__ + "static/media/0021_IMG_LE_SOL_CARRELAGE_EXISTANT.649a54c1.webp";